<div class="flex justify-between items-center gap-1">
  <div  class="!w-[80%] flex gap-1">
  @if (emailVerified !== undefined) {
  <a class="mr-1" style="vertical-align: middle; position: relative; top: 2px;" [title]="
    emailVerified
      ? ('kam.customerDetail.statusTitle.verified' | translate)
      : ('kam.customerDetail.statusTitle.notVerified' | translate)
  ">
    <i class="pi" [ngClass]="{
      'pi-check-circle text-green-500': emailVerified,
      'pi-times-circle text-red-500': !emailVerified
    }"></i>
  </a>
  }
  <div class="!max-w-[85%] ellipsis text-left" [title]="email">{{ email }}</div>
  </div>
  <a class="icon-with-circle copy-icon !m-0" [class.copied]="copied()" (click)="$event.stopPropagation();copyToClipboard(email)" [title]="'copyToClipboard' | translate">
    <i class="pi" [ngClass]="copied() ? 'pi-check' : 'pi-copy'"></i>
  </a>
</div>
